import { Helmet } from 'react-helmet-async'
import { useMemo } from 'react'

import { faGlobe } from '@fortawesome/pro-light-svg-icons'

import {
  Box, Columns, DashboardModule, Table,
} from '@domain-group/suit-theme'

import PageHeader from '@components/PageHeader'
import useProcessingFee from '@hooks/useProcessingFee'
import useAuditLogs from '@hooks/useAuditLogs'

const PageContent = () => {
  const {
    urls: {
      agencyProcessingFeesIndexUrl,
      brandProcessingFeesIndexUrl,
      providerProcessingFeesIndexUrl,
      auditLogProcessingFeesUrl,
    },
  } = useProcessingFee()

  const {
    hasTransformedAuditLogs,
    loading,
    transformedAuditLogs,
  } = useAuditLogs({
    performHttpRequests: true,
  })

  const buildColumns = () => [
    {
      title: 'ID',
      dataKey: 'trackable_id',
    },
    {
      title: 'Activity',
      dataKey: 'activity_type',
    },
    {
      title: 'Time',
      dataKey: 'created_at',
    },
    {
      title: 'Owner Type / ID',
      dataKey: 'owner_type_and_id',
    },
    {
      title: 'Owner Name',
      dataKey: 'owner_name',
    },
    {
      title: 'Debtor Type / ID',
      dataKey: 'debtor_type_and_id',
    },
    {
      title: 'Debtor Name',
      dataKey: 'debtor_name',
    },
    {
      title: 'Service / Product Name',
      dataKey: 'service_or_product_name',
    },
    {
      title: 'Changes',
      dataKey: 'changes',
      render: (value: string) => (value ? (
        <pre
          style={{
            margin: 0,
            whiteSpace: 'pre-wrap',
            wordBreak: 'break-word',
          }}
        >
          {value}
        </pre>
      ) : null),
    },
  ]

  const memoColumns = useMemo(() => buildColumns(), [transformedAuditLogs.length])

  return (
    <>
      <Helmet>
        <title>Processing Fees Audit Log | Realhub</title>
      </Helmet>

      <PageHeader
        activeTabBarItemKey="Audit Log"
        tabBarItems={[
          {
            href: agencyProcessingFeesIndexUrl,
            icon: faGlobe,
            key: 'Agency',
            title: 'Agency',
          },
          {
            href: brandProcessingFeesIndexUrl,
            icon: faGlobe,
            key: 'Brand',
            title: 'Brand',
          },
          {
            href: providerProcessingFeesIndexUrl,
            icon: faGlobe,
            key: 'Provider',
            title: 'Provider',
          },
          {
            href: auditLogProcessingFeesUrl,
            icon: faGlobe,
            key: 'Audit Log',
            title: 'Audit Log',
          },
        ]}
        title="Processing Fees Audit Log"
      />

      <Box paddingX="large" paddingTop={[112, 105]}>
        <Columns boxProps={{ marginTop: 'large' }} flexDirection={['column', 'column', 'row']}>
          <DashboardModule title="Processing Fees Audit Log" contentBoxProps={{ flexDirection: 'column' }}>
            <Table
              boxProps={{ border: 'none', maxHeight: 800, overflowY: 'auto' }}
                // @ts-expect-error TS2322
              columns={memoColumns}
              data={transformedAuditLogs}
              stickyHeader
            />

            {!loading && !hasTransformedAuditLogs && (
            <DashboardModule.BlankState>
              <DashboardModule.BlankState.Title>
                No activities found
              </DashboardModule.BlankState.Title>
            </DashboardModule.BlankState>
            )}
          </DashboardModule>
        </Columns>
      </Box>
    </>
  )
}

export default PageContent
